/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getShifts} from '../api'

 export const useQueryGetShifts = createReactQueryHook('getShifts', getShifts)
